module.exports = __webpack_public_path__ + "img/content7-2.c9966d6c.webp";